export const PASSWORD_ERROR =
  "password should contain min 8 characters with atleast an upper case letter, a lower case letter, a symbol & a number";
export const EMAIL_ERROR = "email is invalid";
export const REQUIRED = "required";
